import { PUBLIC_URL } from '../env'

export const getPhenomenonUrl = (radarId = false, phenomenon, hideEdit = false) => {
  if(!!phenomenon && !!phenomenon?.groups && !!phenomenon?.groups?.length && !phenomenon?.group) {
      // phenomenon['group'] = phenomenon?.radarGroupId || phenomenon?.groups[0]
      phenomenon['group'] = phenomenon?.groups[0]
      
  }
  const { group, id } = phenomenon
  const hasGroup = phenomenon.hasOwnProperty('group')
  const groupUrl = hasGroup ? `group=${group}` : ''

  if (!radarId) {
      return `${PUBLIC_URL}/fp-phenomena/${id}${groupUrl.length ? `/?${groupUrl}` : ''}`
  }

  const urlParams = new URLSearchParams(window.location.search)
  const vsid = urlParams.get('vsid')

  // eslint-disable-next-line
  return `${PUBLIC_URL}/fp-phenomena/${id}${groupUrl.length ? `/?${groupUrl}` : ''}&radar=${radarId}&source_position=right&source_page=radar-view${groupUrl.length ? `&${groupUrl}` : ''}${hideEdit ? '&hideEdit=true' : ''}${vsid ? `&vsid=${vsid}` : ''}`
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  
export function normalisedTimeFormat(originalTime, time=false) {
    if (!!originalTime) {
      const originalTimeSplited = originalTime?.split('-')
      const year = originalTimeSplited[0]
      const month = originalTimeSplited[1]
      const day = originalTimeSplited[2].substring(0,2)
      const hour = originalTimeSplited[2].substring(3,8)

      if(!time) {
      return day + '.' + month + '.'  + year
          
      } else {
        return day + '.' + month + '.' + year +  ' ' + hour
      }
    }
 
}
export function normalisedTimeFormat2(originalTime, time=false) {
      if (!!originalTime) {
        const originalTimeSplited = originalTime?.split('-')
        const year = originalTimeSplited[0]
        const monthNum = parseInt(originalTimeSplited[1], 10)
        const day = parseInt(originalTimeSplited[2].substring(0,2), 10)
        const hour = originalTimeSplited[2].substring(3,8)
        
        // Array of month names
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        const monthName = months[monthNum - 1]

        if(!time) {
          return `${day} ${monthName} ${year}`
        } else {
          return `${day} ${monthName} ${year} ${hour}`
        }
      }
   
  }

  export const innerDimensions = (node) => {
    var computedStyle = window.getComputedStyle
        ? window.getComputedStyle(node ) // Standards
        : node.currentStyle;     // Old IE
    let width = node.clientWidth // width with padding
    let height = node.clientHeight // height with padding
    height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom)
    width -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight)
    return { height, width }
  }

export const getContentTypeSVG = (customTypeStyleColor, contentType = '', isFpGroup = false, fontSizePhen = 16) => {
  // Determine fill color based on content type and custom color
  const getFillColor = () => {
    if (String(customTypeStyleColor) === "none") {
      switch (contentType) {
        case "rising":
          return "#00CA8D";
        case "weaksignal":
          return "#A8A8A8";
        case "summary":
          return "#00CA8D";
        case "cooling":
          return "#0098FF";
        case "wildcard":
          return "#E95757";
        case "established":
          return "#016998";
        case "undefined":
        default:
          return "#00CA8D";
      }
    } else {
      return customTypeStyleColor;
    }
  };

  const fill = getFillColor();
  
  // Return SVG string based on type
  if (String(customTypeStyleColor) === "none") {
    if (contentType !== "undefined" && contentType !== "summary") {
      // Standard type SVG
      const fpGroupElement = isFpGroup ? `
        <g opacity="0.4">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.39548 11.3009C8.68303 11.276 8.54793 9.51962 8.56005 7.87303C8.57394 6.11953 8.80896 5.3844 9.28018 5.12783C9.62163 4.94156 10.7636 5.01273 10.8189 5.01624C12.3857 5.11406 13 6.16142 13 7.13057C13 9.04749 11.8787 9.21063 10.9247 9.80489C10.1535 10.2852 10.113 11.3009 9.39548 11.3009Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.91364 5.70345C7.90684 5.16631 7.52282 5.07522 7.08708 5.03656C6.68917 5.00053 5.47623 4.9774 4.9175 5.06292C4.13824 5.18329 4.02413 6.49336 4.00255 7.92937C3.9789 9.53818 4.10986 11.2551 4.81078 11.2996C4.81522 11.2996 4.81965 11.3005 4.82379 11.3005C5.0665 11.309 5.23441 11.2026 5.37394 11.0421C5.57851 10.807 5.71982 10.454 5.94863 10.1726C6.36694 9.65914 6.65281 9.52119 7.09742 9.1466C7.77499 8.57577 7.43354 7.87109 7.44833 7.33277C7.45956 6.93884 7.58697 6.67964 7.64314 6.56717C7.83825 6.1747 7.9163 5.92575 7.91364 5.70345Z"
            fill="white"
          />
        </g>` : '';
      
      return `<svg width="${fontSizePhen}" height="${fontSizePhen}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="${fill}" />
        ${fpGroupElement}
      </svg>`;
    } 
    else if (contentType === "summary") {
      // Summary type SVG
      const fpGroupElement = isFpGroup ? `
        <g opacity="0.4">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.3955 13.8009C10.683 13.776 10.5479 12.0196 10.56 10.373C10.5739 8.61953 10.809 7.8844 11.2802 7.62783C11.6216 7.44156 12.7636 7.51273 12.8189 7.51624C14.3857 7.61406 15 8.66142 15 9.63057C15 11.5475 13.8787 11.7106 12.9247 12.3049C12.1535 12.7852 12.113 13.8009 11.3955 13.8009Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.91364 8.20345C9.90684 7.66631 9.52282 7.57522 9.08708 7.53656C8.68917 7.50053 7.47623 7.4774 6.9175 7.56292C6.13824 7.68329 6.02413 8.99336 6.00255 10.4294C5.9789 12.0382 6.10986 13.7551 6.81078 13.7996C6.81522 13.7996 6.81965 13.8005 6.82379 13.8005C7.0665 13.809 7.23441 13.7026 7.37394 13.5421C7.57851 13.307 7.71982 12.954 7.94863 12.6726C8.36694 12.1591 8.65281 12.0212 9.09742 11.6466C9.77499 11.0758 9.43354 10.3711 9.44833 9.83277C9.45956 9.43884 9.58697 9.17964 9.64314 9.06717C9.83825 8.6747 9.9163 8.42575 9.91364 8.20345Z"
            fill="white"
          />
        </g>` : '';
      
      return `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10.5" cy="10.5" r="10.5" fill="${fill}" />
        <path
          d="M10.5 18.5C14.9183 18.5 18.5 14.9183 18.5 10.5C18.5 6.08172 14.9183 2.5 10.5 2.5C6.08172 2.5 2.5 6.08172 2.5 10.5C2.5 14.9183 6.08172 18.5 10.5 18.5Z"
          fill="#00CA8D"
          stroke="white"
        />
        ${fpGroupElement}
      </svg>`;
    } 
    else {
      // Undefined type SVG
      const fpGroupElement = isFpGroup ? `
        <g opacity="0.5">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.22104 10.8883C8.59765 10.8665 8.47944 9.32967 8.49004 7.8889C8.5022 6.35459 8.70784 5.71135 9.12016 5.48685C9.41892 5.32386 10.4182 5.38614 10.4665 5.38921C11.8375 5.47481 12.375 6.39124 12.375 7.23925C12.375 8.91656 11.3939 9.0593 10.5591 9.57928C9.88427 9.99957 9.84883 10.8883 9.22104 10.8883Z"
            fill="#00CA8D"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.92443 5.99055C7.91848 5.52055 7.58247 5.44085 7.20119 5.40702C6.85302 5.3755 5.7917 5.35525 5.30281 5.43008C4.62096 5.53541 4.52112 6.68172 4.50223 7.93823C4.48154 9.34594 4.59613 10.8482 5.20943 10.8872C5.21332 10.8872 5.2172 10.8879 5.22082 10.8879C5.43318 10.8954 5.58011 10.8023 5.7022 10.6619C5.8812 10.4561 6.00484 10.1473 6.20505 9.90103C6.57107 9.45178 6.82121 9.33108 7.21024 9.0033C7.80311 8.50383 7.50435 7.88723 7.51729 7.4162C7.52711 7.07151 7.6386 6.84471 7.68775 6.7463C7.85847 6.4029 7.92676 6.18506 7.92443 5.99055Z"
            fill="#00CA8D"
          />
        </g>` : '';
      
      return `<svg width="${fontSizePhen}" height="${fontSizePhen}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="7" fill="${fill}" />
        <circle cx="8" cy="8" r="5.25" fill="white" />
        ${fpGroupElement}
      </svg>`;
    }
  } 
  else {
    // Custom color circle SVG
    return `<svg width="${fontSizePhen}" height="${fontSizePhen}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="${fill}" />
    </svg>`;
  }
};

// Function to encode SVG for use in img src
export const getSVGDataUrl = (svgString) => {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;
};

// Helper function to get raw SVG code for content type 
export const getContentTypeRawSVG = (customTypeStyleColor, contentType, isFpGroup = false, fontSizePhen = 16) => {
  // Get the SVG string
  const svgString = getContentTypeSVG(customTypeStyleColor, contentType, isFpGroup, fontSizePhen);
  // Escape double quotes to prevent JSON parsing issues when sending to server
  return svgString.replace(/"/g, '\\"');
};

// Helper function to directly get image src for content type
export const getContentTypeImageSrc = (customTypeStyleColor, contentType, isFpGroup, fontSizePhen) => {
  const svgString = getContentTypeSVG(customTypeStyleColor, contentType, isFpGroup, fontSizePhen);
  // return getSVGDataUrl(svgString);
  return svgString;
};

/**
 * Injects content type SVG images into HTML content
 * This function replaces placeholders like {{contentType:rising}} with actual SVG images
 * 
 * @param {string} htmlContent - The HTML content containing placeholders
 * @param {boolean} isFpGroup - Whether the content is from an FP group
 * @returns {string} - The HTML content with SVG images injected
 */
export const injectContentTypeSVGs = (htmlContent, isFpGroup = false) => {
  if (!htmlContent) return '';
  
  // Find all content type placeholders using regex
  const regex = /\{\{contentType:([\w]+)(?:\:([\w#]+))?\}\}/g;
  
  // Replace each placeholder with the actual SVG image
  return htmlContent.replace(regex, (match, contentType, customColor = 'none') => {
    // Generate SVG for this content type
    const svgString = getContentTypeSVG(customColor, contentType, isFpGroup, 16);
    const dataUrl = getSVGDataUrl(svgString);
    
    // Return an img tag with the SVG
    return `<img src="${dataUrl}" alt="${contentType}" style="vertical-align: middle; width: 16px; height: 16px;" />`;
  });
};

/**
 * Creates a custom HTML with content type visualization
 * 
 * @param {Object} phenomenon - The phenomenon data
 * @param {boolean} isFpGroup - Whether this is from an FP group
 * @returns {string} - HTML string with content type visualization
 */
export const createContentTypeVisualization = (phenomenon, isFpGroup = false) => {
  if (!phenomenon) return '';
  
  const contentType = phenomenon["content-type-alias"] || '';
  const customColor = phenomenon["color"] || 'none';
  const title = phenomenon.title || phenomenon.short_title || '';
  
  // Generate the SVG for this content type
  const svgString = getContentTypeSVG(customColor, contentType, isFpGroup, 16);
  const dataUrl = getSVGDataUrl(svgString);
  
  // Create HTML with visualization
  return `
    <div style="display: flex; align-items: center; margin-bottom: 8px;">
      <img src="${dataUrl}" alt="${contentType}" style="margin-right: 8px; width: 16px; height: 16px;" />
      <span style="font-size: 14px; color: #333;">${contentType}</span>
    </div>
    <div style="font-size: 18px; font-weight: bold; margin-bottom: 12px;">${title}</div>
  `;
};